module.exports = __webpack_public_path__ + "static/media/icon-enquiry-click.019ac16a.svg";